
import React, { useEffect, useState } from 'react';

const RadioButton = (props) => {
    let id = null;
    let callBackFunc = null;
    let data = null;
    let info = null;
    // console.log('is it worked',this)
    props.data == undefined ? data = {} : data = props.data;
    props.info ==  undefined ? info = JSON.stringify({}) : info = JSON.stringify(props.info);
    // console.log('Button props.data', props.data)
    props.onchangeFunction == undefined ? callBackFunc = e => {} : callBackFunc = (event) => props.onchangeFunction(event, data);
    props.btnId == undefined ?  id =  parseInt(Math.random()*1000) : id = props.btnId;

    return(
        <>
            <input type={props.type} className={props.classList} id={id} name={props.name} value={props.value}  data-info={info} onClick={callBackFunc}>{props.children}</input>
        </>
    )
} 

export default RadioButton;